var React = require('react');

function IconFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.547 19.924c0-9.204-7.462-16.666-16.666-16.666-9.205 0-16.667 7.462-16.667 16.666 0 7.817 5.381 14.375 12.64 16.176V25.018h-3.436v-5.094h3.437V17.73c0-5.673 2.567-8.302 8.136-8.302 1.056 0 2.878.207 3.623.414v4.617c-.393-.042-1.076-.063-1.925-.063-2.733 0-3.788 1.036-3.788 3.727v1.801h5.444l-.936 5.094h-4.508v11.451c8.252-.997 14.647-8.023 14.647-16.545z"}));
}

IconFacebookInline.defaultProps = {"width":"40","height":"40"};

module.exports = IconFacebookInline;

IconFacebookInline.default = IconFacebookInline;
